module.exports = __webpack_public_path__ + "files/f04036f9dfa382eae9fa51f2f2ead7a4.png";